import React from 'react';
import styled from 'styled-components';

const Footerbar = styled.div`
    background: #785634;
    color: #f2f2f2;
    text-align:center;
    height:20px;
    align-self:center;
    padding:10px;
`;

export default () =>{
    return <Footerbar>
        @prabhatraushan
    </Footerbar>;
}